import { render, staticRenderFns } from "./garden28.vue?vue&type=template&id=7e897ed1&scoped=true&"
import script from "./garden28.vue?vue&type=script&lang=js&"
export * from "./garden28.vue?vue&type=script&lang=js&"
import style0 from "./garden28.vue?vue&type=style&index=0&id=7e897ed1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e897ed1",
  null
  
)

export default component.exports